module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "imagel"
  }, [_c('a', {
    attrs: {
      "id": "ch008"
    }
  }), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0024-01.jpg",
      "width": "450px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“LIEUTENANT COMMANDER DATA (played by Brent Spiner): An android so perfectly fabricated that, on applying for a Starfleet commission years ago, he tested out as "), _c('em', [_vm._v("alive")]), _vm._v(". This is a point of some pride to Data, whose Starfleet psychiatric profile (‘medical eyes only’) lists the android as having the ‘impossible dream of somehow, some day becoming human….’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Data is so perfectly fabricated that from appearances, you would never know he is not composed of normal flesh and blood. Data’s artificial skin is gold, his eyes an eerie yellow; otherwise, his appearance is that of a human in his mid-thirties….")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Data’s mind/instincts/needs/et cetera are remarkably humanlike—not perfectly so, but in that we find this character’s special qualities. As a Starfleet Academy graduate, he is totally loyal to Starfleet and its regulations—but also capable of being puzzled enough by some Starfleet practices to ask sensible (make that "), _c('em', [_vm._v("too")]), _vm._v(" sensible) questions about them….")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Data serves the vessel as something of a ‘walking library’ with commensurate mental dexterity and reading speed…. He is also enormously strong and agile….")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He is completely incapable of understanding human "), _c('em', [_vm._v("humor")]), _vm._v(", and this has become a running joke in the series. Through his experiences, he has learned many ‘lessons’ about human behavior.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“His most exciting character facets, however, involve his weaknesses and the things he "), _c('em', [_vm._v("cannot")]), _vm._v(" do. He is anything but a ‘cool character’ and constantly exhibits an almost childlike naïveté—which, in fact, has become something of his ‘trademark.’ He is also literal to a fault….”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("—from the "), _c('em', [_vm._v("Star Trek: The Next Generation")]), _vm._v(" writers’/directors’ guide, special edition 1992–93")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0025-01.jpg",
      "width": "450px"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fd51dc0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch008.vue
// module id = 96
// module chunks = 0